import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { LayoutService } from '../../../../../layouts/layout.service';
import { HttpStatusCode } from '../../../../enums/http-status-code.enum';
import { ModuleName } from '../../../../enums/module-name';
import { ApiLogsService } from '../../../../services/api-logs.service';
import { HealthCheckApiStatus } from '../../enums/health-check-api-status.enum';
import { HealthCheckView } from '../../models/health-check.model';
import { IdentityProviderAvailabilityResult } from '../../models/identity-provider-probe.model';
import { IDENTITY_PROVIDER_CHECK_NAME, mapToHealthDetailsView } from '../../utils/helpers';
import { hcColumnSettings, hcColumnSettingsAppraisals, hcMasterSettings } from './health-check-details.config';

@Component({
  selector: 'app-health-check-details',
  templateUrl: './health-check-details.component.html',
  styleUrls: ['./health-check-details.component.scss'],
  standalone: false
})
export class HealthCheckDetailsComponent implements OnInit, OnDestroy {

  subscriptions = new Array<Subscription>();
  loadingData = false;
  apiHealthDetails: HealthCheckView = null;
  apiName = '';

  columnSettings = hcColumnSettings;
  masterSettings = hcMasterSettings;

  HealthCheckApiStatus = HealthCheckApiStatus;
  HttpStatusCode = HttpStatusCode;

  get identityProviderCheck(): IdentityProviderAvailabilityResult | null {
    return this.apiHealthDetails?.checks
      ?.find(c => c.name === IDENTITY_PROVIDER_CHECK_NAME)
      ?.identityProvider ?? null;
  }

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private layoutService: LayoutService,
    private apiLogService: ApiLogsService
  ) { }

  ngOnInit() {
    this.apiName = this.route.snapshot.data.apiName;
    if (this.apiName === ModuleName.Appraisals) {
      this.columnSettings = hcColumnSettingsAppraisals;
    }
    this.getHealthCheckDetails(this.apiName);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }



  getHealthCheckDetails(apiName: string) {
    this.loadingData = true;
    const sub = this.apiLogService
      .getHealthCheckInfo(apiName)
      .pipe(
        map((data: any) => data.code == null ? mapToHealthDetailsView(data) : data),
        finalize(() => this.loadingData = false))
      .subscribe(
        data => this.apiHealthDetails = data,
        errorData => {
          this.layoutService.showUIMessage('Unable to get logs for API');
          this.apiHealthDetails = mapToHealthDetailsView(errorData.error);
        }
      );

    this.subscriptions.push(sub);
  }

  goToPreviousPage() {
    this.location.back();
  }
}
